import { Section, Eyebrow, DisclaimerNote } from "@/components/Primitives";
import LeadForm from "@/components/LeadForm";
import { requestConsultation } from "@/lib/api";

export default function Consultation() {
  return (
    <div className="pb-8">
      <Section className="pt-14 sm:pt-20">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <Eyebrow>The primary next step</Eyebrow>
            <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-stone-900 leading-[1.08] mt-4">
              Request a free 30-minute consultation
            </h1>
            <p className="text-lg text-stone-600 leading-relaxed mt-5">
              This is a calm, no-pressure conversation to understand where you are and whether this
              approach might fit. There's nothing to prepare and nothing to prove.
            </p>
            <ul className="mt-7 space-y-3">
              {[
                "A private, unhurried 30 minutes",
                "We listen first, then clarify together",
                "If it's not the right fit, we'll point you toward better help",
                "Longer sessions are only arranged later, when appropriate",
              ].map((t) => (
                <li key={t} className="flex gap-3 text-stone-700 text-sm">
                  <i className="fa-solid fa-check text-[#4A7C59] mt-0.5" />
                  <span>{t}</span>
                </li>
              ))}
            </ul>
            <DisclaimerNote
              className="mt-8"
              text="Requesting a consultation is not booking a therapy session. We review each request and reach out to arrange a time. If you are in crisis, please contact local emergency or crisis services."
            />
          </div>

          <div className="bg-white rounded-[2rem] border border-stone-200 p-8 shadow-sm">
            <h2 className="font-playfair text-2xl text-stone-900 mb-6">Tell us a little about you</h2>
            <LeadForm
              testIdPrefix="consultation"
              submitLabel="Request my free consultation"
              onSubmit={requestConsultation}
              consentLabel="I consent to being contacted about my consultation request and understand hypnotherapy is a supportive tool that complements appropriate care."
              fields={[
                { name: "name", label: "Full name", required: true, placeholder: "Your name" },
                { name: "email", label: "Email", type: "email", required: true, placeholder: "you@example.com" },
                { name: "phone", label: "Phone (optional)", placeholder: "Best number to reach you" },
                { name: "audience", label: "This is about", placeholder: "e.g. myself, my partner, a family member" },
                { name: "topic", label: "What you'd like support with (optional)", placeholder: "In a sentence or two" },
                { name: "preferred_time", label: "Preferred days / times (optional)", placeholder: "e.g. weekday evenings, Mountain Time" },
                { name: "message", label: "Anything else (optional)", type: "textarea", placeholder: "Share as much or as little as you like" },
              ]}
            />
          </div>
        </div>
      </Section>
    </div>
  );
}
